export var LineHeight;
(function (LineHeight) {
  LineHeight[LineHeight["HEADING1"] = 1.1818181818181819] = "HEADING1";
  LineHeight[LineHeight["HEADING2"] = 1.2222222222222223] = "HEADING2";
  LineHeight[LineHeight["HEADING3"] = 1.1875] = "HEADING3";
  LineHeight[LineHeight["HEADING4"] = 1.4285714285714286] = "HEADING4";
  LineHeight[LineHeight["HEADING5"] = 1.3333333333333333] = "HEADING5";
  LineHeight[LineHeight["REGULAR"] = 1.4285714285714286] = "REGULAR";
  LineHeight[LineHeight["SMALL"] = 1.3333333333333333] = "SMALL";
})(LineHeight || (LineHeight = {}));